module.exports = __webpack_public_path__ + "img/call-app.d4e407f7.png";